export default __webpack_public_path__ + "desktop-monitor.png";